import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getTeam } from "../api/teams";
import PageLoader from "../components/PageLoader";
import ManageTeam from "../components/sidekick/teams/ManageTeam";
import { Page, PageHeader } from "../components/ui";

const UpdateTeam = () => {
  const { teamId } = useParams();

  const teamMembersQuery = useQuery(
    ["team-members", teamId],
    () => {
      return getTeam(teamId);
    },
    {
      keepPreviousData: true,
      staleTime: 60000,
    },
  );

  if (teamMembersQuery.isLoading) return <PageLoader />;

  console.log(teamMembersQuery);

  const team = teamMembersQuery?.data?.data?.data;

  return (
    <Page>
      <PageHeader
        back={{ to: "/admin/teams", label: "Teams" }}
        title={team?.name ?? "Manage team"}
      />
      <ManageTeam data={team} />
    </Page>
  );
};

export default UpdateTeam;
